import { render, staticRenderFns } from "./OAuth2Result.vue?vue&type=template&id=2afdc70a"
import script from "./OAuth2Result.vue?vue&type=script&lang=js"
export * from "./OAuth2Result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports